const STORAGE_KEY = 'argumentor-pending-invitation';
let pending;

// Capture before rendering or initializing third-party scripts. Retain only
// this tab's invitation, so another account's tab cannot consume it.
export function getPendingInvitation() {
  if (pending !== undefined) return pending;
  const url = new URL(window.location.href);
  const conflictId = url.searchParams.get('invite');
  if (conflictId) {
    pending = { conflictId, email: url.searchParams.get('email') || '', receivedAt: Date.now() };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending)); } catch (_) { /* memory fallback */ }
    url.searchParams.delete('invite');
    url.searchParams.delete('email');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  } else {
    try { pending = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || null; } catch (_) { pending = null; }
  }
  return pending;
}

export function clearPendingInvitation() {
  pending = null;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { /* memory fallback */ }
}

export function isInvitationForUser(invitation, user, conflict) {
  const email = user?.email?.trim().toLowerCase();
  if (!invitation || !email || !conflict || conflict.id !== invitation.conflictId) return false;
  if (invitation.email && invitation.email.trim().toLowerCase() !== email) return false;
  return conflict.mentees?.some(person => person.id === user.id || person.email?.trim().toLowerCase() === email) === true;
}

export function hasSensitiveAdContext() {
  if (getPendingInvitation()) return true;
  return [window.location.href, document.referrer].some(value => {
    if (!value) return false;
    try {
      const params = new URL(value).searchParams;
      return ['invite', 'email', 'oobCode', 'mode'].some(key => params.has(key));
    } catch (_) { return true; }
  });
}
